import { Component, Input, OnInit } from '@angular/core';
import { BaseStudentOnboardingStepViewModel } from 'edu-application/dist/onboarding/base/base.onboarding.model';
import { StudentInfo } from 'edu-core';

@Component({
  selector: 'edu-view-student-onboarding',
  templateUrl: './view-student-onboarding.component.html',
  styleUrls: ['./view-student-onboarding.component.scss']
})
export class ViewStudentOnboardingComponent implements OnInit {
  onboardingSteps: BaseStudentOnboardingStepViewModel[] = [];
  student: StudentInfo;
  @Input('steps') studentOnboardingSteps: BaseStudentOnboardingStepViewModel[];
  @Input('type') viewType: 'admin' | 'student';
  @Input() studentId?: string;

  constructor(
  ) { }

  ngOnInit(): void {
    this.onboardingSteps = this.studentOnboardingSteps;
  }
  onclickstep(): void {
    console.log('step clicked');
  }


}
